<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow v-for="grocer in grocers" :key="grocer.title">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ grocer.title }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="grocersEnabled[grocer.id]"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';

    export default {

        name: 'PartnerGrocers',
        components: {
            PartnersTabLinks,
        },

        data() {
            return {
                partner: {},
                grocers: [],
                grocersEnabled: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.grocers) partner.grocers = [];
                    this.partner = partner;
                    Vue.axios
                        .get('/grocers/')
                        .then(resp => {
                            this.grocers = resp.data;
                            this.initGrocersEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                this.partner.grocers = [];
                for (var i = 0; i < this.grocers.length; i++) {
                    if (this.grocersEnabled[this.grocers[i].id]) {
                        this.partner.grocers.push(this.grocers[i].id);
                    }
                }
                Vue.axios
                    .put('/partners/' + this.partner.id + '/grocers', {
                        grocers: this.partner.grocers,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            initGrocersEnabled() {
                this.grocersEnabled = [];
                for (var i = 0; i < this.grocers.length; i++) {
                    this.grocersEnabled[
                        this.grocers[i].id
                    ] = this.partner.grocers.includes(this.grocers[i].id);
                }
            },
            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>
